import { NgModule } from '@angular/core';
import { LayoutComponent } from 'app/shared/components/layout/layout.component';
import { EmptyLayoutModule } from 'app/shared/components/layout/layouts/empty/empty.module';
import { CenteredLayoutModule } from 'app/shared/components/layout/layouts/horizontal/centered/centered.module';
import { EnterpriseLayoutModule } from 'app/shared/components/layout/layouts/horizontal/enterprise/enterprise.module';
import { MaterialLayoutModule } from 'app/shared/components/layout/layouts/horizontal/material/material.module';
import { ModernLayoutModule } from 'app/shared/components/layout/layouts/horizontal/modern/modern.module';
import { ClassicLayoutModule } from 'app/shared/components/layout/layouts/vertical/classic/classic.module';
import { ClassyLayoutModule } from 'app/shared/components/layout/layouts/vertical/classy/classy.module';
import { CompactLayoutModule } from 'app/shared/components/layout/layouts/vertical/compact/compact.module';
import { DenseLayoutModule } from 'app/shared/components/layout/layouts/vertical/dense/dense.module';
import { FuturisticLayoutModule } from 'app/shared/components/layout/layouts/vertical/futuristic/futuristic.module';
import { ThinLayoutModule } from 'app/shared/components/layout/layouts/vertical/thin/thin.module';
import { CommonModule } from '@angular/common';
import { SettingsModule } from '../settings/settings.module';
import { FuseAlertModule } from '@fuse/components/alert';

const layoutModules = [
  // Empty
  EmptyLayoutModule,

  // Horizontal navigation
  CenteredLayoutModule,
  EnterpriseLayoutModule,
  MaterialLayoutModule,
  ModernLayoutModule,

  // Vertical navigation
  ClassicLayoutModule,
  ClassyLayoutModule,
  CompactLayoutModule,
  DenseLayoutModule,
  FuturisticLayoutModule,
  ThinLayoutModule,
];

@NgModule({
  declarations: [LayoutComponent],
  imports: [CommonModule, SettingsModule, FuseAlertModule, ...layoutModules],
  exports: [LayoutComponent, ...layoutModules],
})
export class LayoutModule {}
